import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack } from "IZOX/_X";
import PIPolicy from "./_gears/PIPolicy";

/**
 * @augments {Component<Props, State>}
 */
class PIContainer extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PIContainer.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    let {children} = this.props;
    return (
      <VStack fullWidth minHeight={"100%"} bgColor={ColorX.CSS("Grass")} pT={30} VAlign="^">
        <HStack spacing={16} VAlign="^">
          <VStack width={157} spacing={16}>
            <PIPolicy/>
          </VStack> 
          <VStack width={1120}>
            {children}
          </VStack>
        </HStack>
      </VStack>
    );
  }

}

export default observer(PIContainer);
